import type { EInvoiceObservation } from '@/lib/api/einvoice-observation'
import { m } from '@/lib/paraglide/messages'

export function observationLabel(observation: EInvoiceObservation) {
    switch (observation.publication) {
        case 'published':
            return m.einvoice_published_misa()
        case 'draft':
            return m.einvoice_draft_title()
        case 'processing':
            return m.einvoice_badge_issuing()
        case 'failed':
            return m.einvoice_publication_failed()
        default:
            return m.einvoice_badge_unknown()
    }
}

function taxLabel(tax: EInvoiceObservation['tax']) {
    switch (tax.state) {
        case 'pending_code':
            return m.einvoice_tax_pending_code()
        case 'code_granted':
            return m.einvoice_tax_code_granted()
        case 'not_sent':
            return m.einvoice_tax_not_sent()
        case 'sent':
            return m.einvoice_tax_sent()
        case 'accepted':
            return m.einvoice_tax_accepted()
        case 'rejected':
            return tax.kind === 'with_code'
                ? m.einvoice_badge_rejected()
                : m.einvoice_tax_rejected()
        case 'send_error':
            return m.einvoice_tax_send_error()
        default:
            return tax.kind === 'mtt'
                ? m.einvoice_tax_mtt_unknown()
                : m.einvoice_tax_unknown()
    }
}

export function EInvoiceObservationNotice({
    observation,
}: {
    observation: EInvoiceObservation
}) {
    const { lifecycle, publication, tax } = observation
    const mttUnknown =
        publication === 'published' &&
        tax.kind === 'mtt' &&
        tax.state === 'unknown'
    return (
        <div className="space-y-1 text-sm">
            <p className="font-medium">
                {mttUnknown
                    ? m.einvoice_mtt_published_unknown()
                    : observationLabel(observation)}
                {observation.inv_no && ` #${observation.inv_no}`}
            </p>
            {publication === 'published' && !mttUnknown && (
                <p>{taxLabel(tax)}</p>
            )}
            {lifecycle.is_deleted && (
                <p className="text-destructive">
                    {m.einvoice_deleted_warning()}
                </p>
            )}
            {lifecycle.reference_role === 'replacement' && (
                <p>{m.einvoice_replacement_warning()}</p>
            )}
            {lifecycle.reference_role === 'adjustment' && (
                <p>{m.einvoice_adjustment_warning()}</p>
            )}
            {lifecycle.reference_role === 'unknown' &&
                lifecycle.reference_type !== null &&
                lifecycle.reference_type !== 0 && (
                    <p>
                        {m.einvoice_reference_unknown({
                            code: lifecycle.reference_type,
                        })}
                    </p>
                )}
            {observation.observed_at && (
                <p className="text-xs text-muted-foreground">
                    {m.einvoice_observed_at({
                        time: new Intl.DateTimeFormat('vi-VN', {
                            dateStyle: 'short',
                            timeStyle: 'short',
                            timeZone: 'Asia/Ho_Chi_Minh',
                        }).format(new Date(observation.observed_at)),
                    })}
                </p>
            )}
        </div>
    )
}
